import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import lokasiShiftService from "../../../services/ref/lokasiShiftService";
import Cookies from "js-cookie";

export const initialState = {
    loading_lokasi_shift: false,
    data_lokasi_shift: [],
    showMessage:false,
    message:'',
}


export const getDataLokasiShift = createAsyncThunk('lokasi_shift/data',async (data, { rejectWithValue }) => {
    try {
        const response = await lokasiShiftService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const lokasiShiftSlice = createSlice({
    name: 'lokasi_shift',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_lokasi_shift = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataLokasiShift.fulfilled, (state, action) => {
                state.loading_lokasi_shift = false
                state.data_lokasi_shift = action.payload??[]
            })
            .addCase(getDataLokasiShift.pending, (state) => {
                state.loading_lokasi_shift = true
            })
            .addCase(getDataLokasiShift.rejected, (state, action) => {
                state.loading_lokasi_shift = false
                state.data_lokasi_shift = action.payload
            })
    },
})

export const {
    showLoading,
} = lokasiShiftSlice.actions

export default lokasiShiftSlice.reducer
